import {Component,ViewEncapsulation,OnInit,OnChanges,ViewChild,ElementRef, AfterViewInit, EventEmitter, Output} from "@angular/core";
import Stepper from "bs-stepper";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AdesaoModel } from 'src/app/models/adesao.model';
import { AdesaoService } from 'src/app/services/adesao.service';
import { UtilService } from 'src/app/services/util.service';
import { AdesaoTermosAceitesComponent } from '../adesao-termos-aceites/adesao-termos-aceites.component';
import { AdesaoDadosPessoaisTitularComponent } from '../adesao-dados-pessoais-titular/adesao-dados-pessoais-titular.component';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { RecebimentosService } from 'src/app/services/recebimentos.service';
import { finalize } from 'rxjs/operators';
import { FimAdesaoComponent } from "../fim-adesao/fim-adesao.component";
import { AdesaoContribuicaoComponent } from "../adesao-contribuicao/adesao-contribuicao.component";
import { ChangeDetectorRef } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from "@angular/forms";

declare var $: any;



@Component({
    selector: "app-adesao",
    templateUrl: "./adesao.component.html",
    styleUrls: ["./adesao.component.css"],
    imports: [ReactiveFormsModule, FormsModule, AdesaoContribuicaoComponent, FimAdesaoComponent, AdesaoTermosAceitesComponent],
    providers: [AdesaoContribuicaoComponent],
    encapsulation: ViewEncapsulation.None
})
export class AdesaoComponent implements OnInit, OnChanges {

  @ViewChild("box", { read: ElementRef, static: true }) box: ElementRef;
  @ViewChild("header", { read: ElementRef, static: true }) header: ElementRef;
  @ViewChild(AdesaoTermosAceitesComponent,{static:true}) adesaoTermos: AdesaoTermosAceitesComponent;
  @ViewChild("vinculoHeader", { read: ElementRef, static: true }) vinculoHeader: ElementRef;
  @ViewChild("vinculoBody", { read: ElementRef, static: true }) vinculoBody: ElementRef;
  @ViewChild(AdesaoTermosAceitesComponent, {static: true}) termosAceitesComp: AdesaoTermosAceitesComponent;
  @ViewChild(FimAdesaoComponent, {static:true}) fimAdesaoComp: FimAdesaoComponent;
  @ViewChild(AdesaoContribuicaoComponent, {static:true}) adesaoContribComp: AdesaoContribuicaoComponent;




  public parentForm: FormGroup = null;
  loadingFinalizar: boolean = false;

  numTela: string = "1";

  BtnCloseAdesao: boolean = false;
  enabledTabSeven: boolean = false;
  enableTabRegimeTributacao: boolean = false;
  botaoAtivo: boolean = false; // Inicia desativado

  temFusan:boolean = false;
  menorDeIdade: boolean = false;
  checkedVinculo:string = "";
  tab:string = 'one';
  adesaoFinalizada:boolean = false;
  loading: boolean = false;
  dadosBoleto: any = null;
  data_nascimento: Date = null;

  participante = {
    nome:"",
    cpf: "",
    rg:"",
    endereco:"",
    dataAtual: new Intl.DateTimeFormat('pt-BR', { dateStyle: 'long' }).format(new Date())
  };


  model: AdesaoModel = new AdesaoModel();
  private stepper: Stepper;
  assinatura: String;

  public constructor(
                      private adesao: AdesaoService,
                      private autenticacao: AutenticacaoService,
                      private util: UtilService,
                      private router: Router,
                      private toastr: ToastrService,
                      private recebimentos: RecebimentosService,
                      private cdRef: ChangeDetectorRef
                    ) {

                      //this.verificaRegimeTributacao()


    this.parentForm = new FormGroup({
        step:new FormControl(1,[]),
        concluido:new FormControl(false,[]),
        dataBoleto:new FormControl(null),
        dadosPessoais : new FormGroup({
          rg: new FormControl(null),
          orgExpeditor: new FormControl(null),
          dtaExpedicao: new FormControl(null),
          nacionalidade: new FormControl(null),
          codEstadoCivil: new FormControl(null),
          nomeConjuge: new FormControl(null),
          nomeMae: new FormControl(null),
          nomePai: new FormControl(null),
          naturalidade: new FormControl(null),
          dataNascimento: new FormControl(null, [Validators.required]),
          genero: new FormControl(null),
          ocupacao: new FormControl(null),
          codCbo: new FormControl(null),
          menorDeIdade: new FormControl(false, [])
        }),

        representante: new FormGroup({
          numdCodPart:new FormControl(null),
          nomeRep: new FormControl(null, [Validators.required]),
          cpfRep: new FormControl(null, [Validators.required,Validators.minLength(14)]),
          cpfRepIsValid: new FormControl(null),
          DDITelefRep: new FormControl(null),
          DDDTelefRep: new FormControl(null),
          telRep: new FormControl(null, [Validators.required]),
          emailRep:new FormControl(null,[Validators.required, Validators.email]),
          codRepTipo: new FormControl("",[Validators.required]),
        }),

        end : new FormGroup({
          cep: new FormControl(null),
          endereco: new FormControl(null),
          numero:new FormControl(null),
          compl: new FormControl(null),
          bairro: new FormControl(null),
          uf: new FormControl(""),
          codCidade: new FormControl(""),
        }),

        vinculo : new FormGroup({
          codVinculo: new FormControl(null, [Validators.required]),
          codInstituidor: new FormControl(null, [Validators.required]),
          decMostraVinculo: new FormControl(null, [Validators.required]),
          cpfAssociado: new FormControl(null, [Validators.required,Validators.minLength(14)]),
          cpfIsValid:new FormControl(null),
          nomeAssociado: new FormControl(null, [Validators.required]),
          sobrenomeAssociado: new FormControl(null, [Validators.required]),
          CodParentescoAssociado:new FormControl(null, [Validators.required]),
          idcTermoVinculo:new FormControl("N", [Validators.required]),
          dcrCarteiraAspp: new FormControl(null, [Validators.required]),
        }),

        tributacao: new FormGroup({
          decTributacao: new FormControl(null, [Validators.required]),
        }),

        contribuicao : new FormGroup({
          vlrCtb: new FormControl(null, [Validators.required]),
          vlrCtbRange:new FormControl(null, [Validators.required]),
          vlrPrimeiroAporteCtb: new FormControl(null, [Validators.required]),
          vlrPrimeiroAporteCtbRange:new FormControl(null, [Validators.required]),
          idadeApos: new FormControl(null, [Validators.required,Validators.min(18)]),
          idadeAposRange: new FormControl(0, [Validators.required]),
          idcPrimerioAporte : new FormControl(0, [Validators.required]),
        }),

        beneficiario : new FormGroup({
          temBenef:new FormControl(false, [Validators.requiredTrue])
        }),

        termos : new FormGroup({
          decPPE: new FormControl(null, [Validators.required]),
          decLGPD: new FormControl(null, [Validators.required]),
          decUSPerson: new FormControl(null, [Validators.required]),
          idcPais:new FormControl(null, [Validators.required]),
          idcAutDadosPessoais:new FormControl(null, [Validators.required]),
          decInstituidor: new FormControl('N'),
          nifok: new FormControl(false, [Validators.requiredTrue])
        }),

        assinaturaEletronica: new FormGroup({
          assinatura: new FormControl(null)
          //assinatura: new FormControl(null,[Validators.required, Validators.minLength(8)])
        })

    });

  }


  ngOnInit() {
    this.iniciaStepper();
    this.carregar();

    this.verificaAdesaoFinalizada();
  }

  ngAfterViewInit() {
    // Escutar evento do filho quando o componente já estiver carregado
    this.fimAdesaoComp.ativarBotao.subscribe((valor: boolean) => {
      //this.stepper.to(3);
      this.botaoAtivo = valor;
    });


    // Chamar a função do filho para verificar cobrança ao iniciar
    //this.fimAdesaoComp.verificaCobrancaPaga();
  }


  verificaAdesaoFinalizada(){
    let cpf = this.autenticacao.getCredenciais().cpf;
    this.adesao.verificaAdesaoFinalizada(cpf)
    .subscribe(
      (finalizada: boolean)=>{
        if(finalizada){
          this.router.navigate(['/logado/adesao/fim-adesao']);
        }
      }
    )
  }


  iniciaStepper(){
    this.calcularTamanhoItens();

    this.stepper = new Stepper(document.querySelector("#stepper1"), {
      linear: false,
      animation: true
    });
  }


  carregar(){

    this.adesao.carregar()
    .subscribe(
      (res:any)=>{

        // dados Pessoais
        if(res.DTA_NASC != null){
          this.adesaoContribComp.setDataNasc(res.DTA_NASC);
          this.data_nascimento = res.DTA_NASC;
        }

        this.parentForm.get("dadosPessoais.genero").setValue(res.COD_SEXO);
        this.parentForm.get("dadosPessoais.codEstadoCivil").setValue(res.COD_ESTADO_CIVIL);
        this.parentForm.get("dadosPessoais.nacionalidade").setValue(res.DCR_NACIONALIDADE);
        this.parentForm.get("dadosPessoais.orgExpeditor").setValue(res.DCR_ORGEXP_IDENT);
        this.parentForm.get("dadosPessoais.dtaExpedicao").setValue(res.DTA_EXP_IDENT != null ? Intl.DateTimeFormat('pt-BR').format(new Date(res.DTA_EXP_IDENT.replace(/-/g, '\/'))) : null);
        this.parentForm.get("dadosPessoais.nomeConjuge").setValue(res.NOM_CONJUGE); 
        this.parentForm.get("dadosPessoais.nomeMae").setValue(res.NOM_MAE);
        this.parentForm.get("dadosPessoais.nomePai").setValue(res.NOM_PAI);
        this.parentForm.get("dadosPessoais.naturalidade").setValue(res.DCR_NATURALIDADE);
        this.parentForm.get("dadosPessoais.ocupacao").setValue(res.DCR_OCUP_PROF);
        this.parentForm.get("dadosPessoais.codCbo").setValue(res.NUM_CBO);
        this.parentForm.get("dadosPessoais.rg").setValue(res.DCR_RG_IDENT);

       

        //representante
        this.parentForm.get("representante.numdCodPart").setValue(res.COD_PF_REP_LEGAL);
        this.parentForm.get("representante.nomeRep").setValue(res.NOME_REP_LEGAL);
        this.parentForm.get("representante.cpfRep").setValue(res.DCR_CPF_REP_LEGAL);
        this.parentForm.get("representante.DDITelefRep").setValue("");

        if(res.DCR_DDD_CELULAR_REP_LEGAL != null){
          this.parentForm.get("representante.DDDTelefRep").setValue(res.DCR_DDD_CELULAR_REP_LEGAL);
          this.parentForm.get("representante.telRep").setValue(res.DCR_DDD_CELULAR_REP_LEGAL + res.DCR_CELULAR_REP_LEGAL);
        }

        this.parentForm.get("representante.emailRep").setValue(res.DCR_EMAIL_REP_LEGAL);
        this.parentForm.get("representante.codRepTipo").setValue(res.COD_REP_TIPO);

        //instituidor e vínculo
        this.parentForm.get("vinculo.codVinculo").setValue(res.COD_VINCULO);
        this.parentForm.get("vinculo.codInstituidor").setValue(res.COD_INSTITUIDOR);
        this.parentForm.get("vinculo.decMostraVinculo").setValue(res.DEC_MOSTRA_VINCULO);


        this.parentForm.get("termos.decInstituidor").setValue(res.DEC_INSTITUIDOR);
        this.parentForm.get("vinculo.cpfAssociado").setValue(res.DCR_CPF_ASSOCIADO);

        this.parentForm.get("vinculo.dcrCarteiraAspp").setValue(res.DCR_CARTEIRA_ASPP);


        if(res.NOME_ASSOCIADO != null){
          let arrayNome: string[] = res.NOME_ASSOCIADO.split(" ");
          let nome = arrayNome.shift();
          let sobreNome = arrayNome.join(' ');
          this.parentForm.get("vinculo.nomeAssociado").setValue(nome);
          this.parentForm.get("vinculo.sobrenomeAssociado").setValue(sobreNome);
        }
        this.parentForm.get("vinculo.CodParentescoAssociado").setValue(res.COD_PARENTESCO_ASSOCIADO);
        this.parentForm.get("vinculo.idcTermoVinculo").setValue(res.DEC_DECL_ASSOCIADO);

       // alert(res.DEC_TRIBUTACAO);

        //tributação
        this.parentForm.get("tributacao.decTributacao").setValue(res.DEC_TRIBUTACAO);

        //Contribuição
        const formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2
        });

        this.parentForm.get("contribuicao.vlrCtb").setValue(formatter.format(res.VLR_CTB));
        this.parentForm.get("contribuicao.vlrCtbRange").setValue(Number(res.VLR_CTB));

        this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue(formatter.format(res.aporte_ini_cod_cobranca));
        this.parentForm.get("contribuicao.vlrPrimeiroAporteCtbRange").setValue(Number(res.aporte_ini_cod_cobranca));

        if (this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue !== null && this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue !== undefined) {
             this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue(formatter.format(res.VLR_CTB));
             this.parentForm.get("contribuicao.vlrPrimeiroAporteCtbRange").setValue(Number(res.VLR_CTB));
             this.parentForm.get("contribuicao.idcPrimerioAporte").setValue(1);
        }

        if(res.NUM_IDADE_APOS != null){
          this.parentForm.get("contribuicao.idadeApos").setValue(res.NUM_IDADE_APOS.toString());
          this.parentForm.get("contribuicao.idadeAposRange").setValue(res.NUM_IDADE_APOS);

        }

        //termos
        this.parentForm.get("termos.decPPE").setValue(res.DEC_PPE);
        this.parentForm.get("termos.decLGPD").setValue(res.DEC_LGPD);
        this.parentForm.get("termos.decUSPerson").setValue(res.DEC_USPERSON);
        this.parentForm.get("termos.idcAutDadosPessoais").setValue(res.DEC_INFORMACOES);
        this.parentForm.get("termos.idcPais").setValue(res.DEC_NACIONALIDADES);

        this.participante.cpf = res.DCR_CPF;
        this.participante.rg = res.DCR_RG_IDENT;
        this.participante.nome = res.NOME;
        this.participante.endereco = res.DCR_END;
        this.adesaoTermos.listarNif();

        this.validadeIdade();

      }
    )
  }


  // avança ao proximo passo da adesão
  next(numTab:string = "") {

    this.numTela = numTab

    if(this.numTela == '1'){

       this.parentForm.get("step").setValue(Number(1))
       this.fimAdesaoComp.verificaCobrancaPaga();

    }else{

      var numCarteiraASPP = this.parentForm.get('vinculo.dcrCarteiraAspp').value;
      var codVinculo = this.parentForm.get("vinculo.codVinculo").value;

      if(this.numTela == '2' && codVinculo == 12 && (numCarteiraASPP == null || numCarteiraASPP == '')){
        alert("Digite o número da Carteira ASPP");
        this.termosAceitesComp.asppError = 'Digite o número da Carteira ASPP';
        return false;
      }

      this.parentForm.get("step").setValue(Number(numTab));
      this.salvar(this.parentForm.getRawValue()); //Se salvo com sucesso, faz um this.stepper.next();

    }

    let credenciais = this.autenticacao.getCredenciais();

    this.participante.cpf = credenciais.cpf;
    this.participante.rg = this.parentForm.get('dadosPessoais.rg').value;
    this.participante.nome = credenciais.nome;

  }

  // salva os dados da adesão
  salvar(form){

      this.adesao
            .salvar(form,"", 1)
            .subscribe(
              (res: any)=>{

                  if(this.numTela=='2' && this.menorDeIdade){
                    this.salvarRepresentante();
                  }else{
                    this.stepper.next();
                  }

              },
              (httpError: HttpErrorResponse)=>{
                this.toastr.error(httpError.error.ex);

                if(httpError.error.type=='aspp'){
                  this.termosAceitesComp.asppError = httpError.error.ex;

                  setTimeout(() =>{
                    this.termosAceitesComp.asppError = "";
                  }, 10000);
                }

              }
            )
  }


  // Insere representante legal caso o titular seja menor de idade
  //favor rever
  salvarRepresentante(){

    if(this.menorDeIdade !=  false)
    {

      this.adesao.salvarRepresentante(this.parentForm.get("representante").value)
      .subscribe(
        ()=>{
          this.stepper.next();
        },
        (httpError: HttpErrorResponse)=>{
          this.toastr.error(httpError.error.ex);
        }
    )
  }
  }


  backOneTab() {
    this.numTela = "1";
  }

  closeAdesao() {
    return (this.BtnCloseAdesao = true);
  }

  onSubmit() {
    return false;
  }

  onChangePermission(value: any) {
    if (value) {
       this.enabledTabSeven = true;
       this.parentForm.get("termos.decInstituidor").setValue("S")
    }else{
      this.enabledTabSeven = false;
      this.parentForm.get("termos.decInstituidor").setValue("N")
    }
  }


  //Rever se é necessário botar na tela de pré-adesão
  validadeIdade(){

    let dataNascimento = new Date(this.data_nascimento);
    let hoje = new Date();

    let idade = hoje.getFullYear() - dataNascimento.getFullYear();

    // Ajusta a idade caso o aniversário ainda não tenha ocorrido neste ano
    if (
      hoje.getMonth() < dataNascimento.getMonth() ||
      (hoje.getMonth() === dataNascimento.getMonth() && hoje.getDate() < dataNascimento.getDate())
    ) {
      idade--;
    }

    if (idade < 18) {
      this.menorDeIdade = true;
    }

  this.adesaoTermos.setMenorDeIdade(this.menorDeIdade);

}

  ngOnChanges() {

  }


  finalizarAdesao(){

    this.loadingFinalizar = true;

    this.adesao.finalizarAdesao()
    .pipe(
      finalize(() => {this.loadingFinalizar = false})
    )
    .subscribe(
      (res:any)=>{
        this.parentForm.get('concluido').setValue(true);
        sessionStorage.setItem("dataBoleto",res.databoleto.toString());
        sessionStorage.setItem("protocolo",res.protocolo.toString());
        this.router.navigate(['/logado']);
      },
      (httpError: HttpErrorResponse) =>{
        this.toastr.error(httpError.error.ex);
      }
    )
  }



  calcularTamanhoItens(){

    let itens = document.querySelectorAll("div.step");
    let nItens = itens.length;

    document.querySelectorAll("div.step").forEach(el => {
      (el as HTMLElement).style.width = "calc(100% / " + nItens + ")";
    });
  }

  rolarBarraScroll(){

    let scrollLeft = document.querySelector("div.step.active").scrollWidth;
  }

}
